import { getJsonResponse } from "EntitiesApi/Sagas";
import { takeEvery } from "redux-saga";
import { put, call } from "redux-saga/effects";

import { START_REQUEST, receiveAccountSettingData } from "./actions";

import type { StartRequestAction } from "EntitiesApi/Actions";

export function* rootSaga(): Generator<any, any, any> {
  yield takeEvery(START_REQUEST, function* (action: StartRequestAction) {
    try {
      const rawResponse = yield call(getJsonResponse, action);
      yield put(receiveAccountSettingData(rawResponse));
    } catch (e) {
      console.log(e);
    }
  });
}
